/**
 * Created by Ning Jiang on 2/6/2019.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelPartAnimator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartAnimator";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {NudgeSpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelPartAnimator";
import {SpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelPartAnimator";
import {FreespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinZeroBetController";
import {TombstoneBackground} from "./background/TombstoneBackground";
import {GeckoIdleAnimation} from "./idleanimation/GeckoIdleAnimation";
import {TumbleWeedIdleAnimation} from "./idleanimation/TumbleWeedIdleAnimation";
import {WindIdleAnimation} from "./idleanimation/WindIdleAnimation";
import {TombstoneMultiplierController} from "./multiplier/TombstoneMultiplierController";
import {TombstoneSideReelController} from "./reel/reel/TombstoneSideReelController";
import {TombstoneReelAreaView} from "./reel/reelarea/TombstoneReelAreaView";
import {TombstoneBonusAttentionController} from "./reelstoppresentation/bonusattention/TombstoneBonusAttentionController";
import {FreespinRetriggerController} from "./reelstoppresentation/freespinretrigger/FreespinRetriggerController";
import {ReelAttentionController} from "./reelstoppresentation/reelattention/ReelAttentionController";
import {TombstoneScatterAttentionController} from "./reelstoppresentation/scatterattention/TombstoneScatterAttentionController";
import {SuperFreespinAttentionController} from "./reelstoppresentation/superfreespinattention/SuperFreespinAttentionController";
import {WildAttentionController} from "./reelstoppresentation/wildattention/WildAttentionController";
import {TombstoneFreespinIntroController} from "./screen/freespinintro/TombstoneFreespinIntroController";
import {TombstoneFreespinIntroView} from "./screen/freespinintro/TombstoneFreespinIntroView";
import {TombstoneFreespinOutroController} from "./screen/freespinoutro/TombstoneFreespinOutroController";
import {TombstoneFreespinOutroView} from "./screen/freespinoutro/TombstoneFreespinOutroView";
import {TombstoneSuperFreespinIntroController} from "./screen/superfreespinintro/TombstoneSuperFreespinIntroController";
import {TombstoneSuperFreespinOutroController} from "./screen/superfreespinoutro/TombstoneSuperFreespinOutroController";
import {TombstoneParsedGameData} from "./server/data/TombstoneParsedGameData";
import {TombstoneParsedInitData} from "./server/data/TombstoneParsedInitData";
import {TombstoneServerDataParser} from "./server/TombstoneServerDataParser";
import {ShootingGameController} from "./shootinggame/ShootingGameController";
import {TombstoneSpinController} from "./spin/TombstoneSpinController";
import {TombstoneReelSymbol} from "./symbols/TombstoneReelSymbol";
import {TombstoneReelSymbolStateCreator} from "./symbols/TombstoneReelSymbolStateCreator";
import {TombstoneWildSymbol} from "./symbols/TombstoneWildSymbol";
import {TombstoneFontConfig} from "./TombstoneFontConfig";
import {TombstoneGameAssets} from "./TombstoneGameAssets";
import {TombstoneGameConfig} from "./TombstoneGameConfig";
import {TombstoneSoundConfig} from "./TombstoneSoundConfig";
import {TombstoneBigWinController} from "./winpresentation/bigwin/TombstoneBigWinController";
import {TombstoneBonusSymbolWPController} from "./winpresentation/bonus/TombstoneBonusSymbolWPController";
import {TombstoneScatterSymbolWPController} from "./winpresentation/bonus/TombstoneScatterSymbolWPController";
import {TombstoneSuperFreespinSymbolWPController} from "./winpresentation/bonus/TombstoneSuperFreespinSymbolWPController";
import {TombstoneIndividualWPController} from "./winpresentation/individual/TombstoneIndividualWPController";
import {TombstoneInitialWPController} from "./winpresentation/initial/TombstoneInitialWPController";
import {JusticeOutroWPController} from "./winpresentation/justiceoutro/JusticeOutroWPController";
import {TombstonNoWinPresentationController} from "./winpresentation/nowin/TombstonNoWinPresentationController";
import {NudgeWildWPController} from "./winpresentation/nudge/NudgeWildWPController";
import {WildJailController} from "./winpresentation/wildjail/WildJailController";
import {WinWaysIndicator} from "./winpresentation/winways/WinWaysIndicator";
import {SuperFreespinZeroBetController} from "./zerobet/SuperFreespinZeroBetController";
import {TombstoneRespinZeroBetController} from "./zerobet/TombstoneRespinZeroBetController";
import {MaxCapOutroController} from "./winpresentation/capwin/MaxCapOutroController";
import {MaxCapOutroView} from "./winpresentation/capwin/MaxCapOutroView";
import {TBNMSpinReelController} from "./reel/TBNMSpinReelController";

export class TombstoneGameModuleConfig implements IGameModuleConfig {

    public static instance:TombstoneGameModuleConfig = new TombstoneGameModuleConfig();
    private static background:TombstoneBackground;
    private static multiplier:TombstoneMultiplierController;
    private static winWaysIndicator:WinWaysIndicator;
    private static tumbleWeed:TumbleWeedIdleAnimation;
    private static gecko:GeckoIdleAnimation;
    private static wind:WindIdleAnimation;
    public static shootingGame:ShootingGameController;
    public static TBBWController: TombstoneBigWinController;
    public static initData: TombstoneParsedInitData;
    public static gameData: TombstoneParsedGameData;

    GAME_CONFIG:IGameConfig = TombstoneGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = TombstoneSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = TombstoneFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = TombstoneGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => {
        return new TombstoneServerDataParser();
    };
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData = (data, dataParser:ServerDataParser) => {

        // Save refs to data needed for belowStake functionality
        TombstoneGameModuleConfig.initData = new TombstoneParsedInitData(data, <TombstoneServerDataParser>dataParser);

        return TombstoneGameModuleConfig.initData;
    };
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData = (data, dataParser:ServerDataParser) => {

        TombstoneGameModuleConfig.gameData = new TombstoneParsedGameData(data, <TombstoneServerDataParser>dataParser);

        return TombstoneGameModuleConfig.gameData;
    };

    SPIN_CONTROLLER:() => SpinController = () => {
        return new TombstoneSpinController();
    };

    REEL_AREA_VIEW:() => ReelAreaView = () => {
        return new TombstoneReelAreaView();
    };

    REEL_CONTROLLER:(reelId:number) => ReelController = reelId => {
        if(reelId === 0 || reelId === 4) {
            return new TombstoneSideReelController(reelId);
        }
        return new TBNMSpinReelController(reelId);
    };

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.
    REEL_PART_ANIMATOR:(reelId:number) => ReelPartAnimator = reelId => {
        if(reelId === 0 || reelId === 4) {
            return new SpinReelPartAnimator(reelId);
        } else {
            return new NudgeSpinReelPartAnimator(reelId);
        }
    };

    REEL_PART_CREATOR:() => ReelPartCreator = () => {
        return new ReelPartCreator(
            (symName:string, reelId:number, state?:ISymbolStateConfig):TombstoneReelSymbol => {
                if(symName.indexOf("W") > -1) {
                    return new TombstoneWildSymbol(symName, reelId, state);
                }
                return new TombstoneReelSymbol(symName, reelId, state);
            });
    };

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => {
        return new TombstoneReelSymbolStateCreator();
    };

    SCREENS:(() => ScreenController)[] = [
        () => {
            return new MaxCapOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new MaxCapOutroView({
                        layer : TombstoneGameConfig.instance.LAYERS.SCREENS.name,
                        onButtonClickCallback : onButtonClickCallback,
                        mobileScale : 1,
                        portraitScale : 1
                    }, false);
                }
            });
        },
        () => {
            return new TombstoneFreespinIntroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new TombstoneFreespinIntroView({
                        layer : TombstoneGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        },
                        featureNameTexture : "introTextGunslinger",
                        amountTexture : "freespinIntro10",
                        mobileScale : 1.2,
                        portraitScale : 1.4
                    }, autoClose);
                }
            });
        },
        () => {
            return new TombstoneFreespinOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new TombstoneFreespinOutroView({
                        layer : TombstoneGameConfig.instance.LAYERS.FREESPIN_OUTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        },
                        mobileScale : 1.2,
                        portraitScale : 1.4
                    }, autoClose);
                }
            });
        },
        () => {
            return new TombstoneSuperFreespinIntroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new TombstoneFreespinIntroView({
                        layer : TombstoneGameConfig.instance.LAYERS.FREESPIN_INTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        },
                        featureNameTexture : "introTextBounty",
                        amountTexture : "freespinIntro12",
                        mobileScale : 1.2,
                        portraitScale : 1.4
                    }, autoClose);
                }
            });
        },
        () => {
            return new TombstoneSuperFreespinOutroController({
                viewCreator : (onButtonClickCallback:() => void, autoClose?:boolean) => {
                    return new TombstoneFreespinOutroView({
                        layer : TombstoneGameConfig.instance.LAYERS.FREESPIN_OUTRO.name,
                        onButtonClickCallback : onButtonClickCallback,
                        buttonBackgroundConfig : {
                            cornerRadius : 12,
                            lineThickness : 2,
                            lineColor : 0xffffff,
                            lineAlpha : 1,
                            backgroundColor : 0x000000,
                            backgroundAlpha : 0.9
                        },
                        mobileScale : 1.2,
                        portraitScale : 1.4
                    }, autoClose);
                }
            });
        }
    ];

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new FreespinZeroBetController(),
        () => new TombstoneRespinZeroBetController(),
        () => new SuperFreespinZeroBetController()
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        (index:number) => new TombstoneScatterAttentionController(index, {
            numOfScattersToWin : 3,
            scattersMap : [false, true, true, true, false]
        }),
        (index:number) => new TombstoneBonusAttentionController(index),
        (index:number) => new SuperFreespinAttentionController(index),
        (index:number) => new WildAttentionController(index),
        (index:number) => new ReelAttentionController(index),
        (index:number) => new FreespinRetriggerController(index)
    ];


    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new NudgeWildWPController(indexes)],
        [indexes => new TombstonNoWinPresentationController(indexes)],
        [indexes => new TombstoneInitialWPController(indexes)],
        [indexes => TombstoneGameModuleConfig.TBBWController =  new TombstoneBigWinController(indexes)],
        [indexes => new JusticeOutroWPController(indexes)],
        [
            indexes => new TombstoneBonusSymbolWPController(indexes),
            indexes => new TombstoneScatterSymbolWPController(indexes),
            indexes => new TombstoneSuperFreespinSymbolWPController(indexes)
        ],
        [indexes => new WildJailController(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => {
        return new TombstoneIndividualWPController({
            symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
                return 0.2;
            }
        });
    };

    GAME_FEATURE_CREATOR:() => void = () => {
        TombstoneGameModuleConfig.background = new TombstoneBackground({
            layer : TombstoneGameConfig.instance.LAYERS.BACKGROUND.name
        });
        TombstoneGameModuleConfig.multiplier = new TombstoneMultiplierController();
        TombstoneGameModuleConfig.winWaysIndicator = new WinWaysIndicator();
        TombstoneGameModuleConfig.tumbleWeed = new TumbleWeedIdleAnimation();
        TombstoneGameModuleConfig.gecko = new GeckoIdleAnimation();
        TombstoneGameModuleConfig.wind = new WindIdleAnimation();
        TombstoneGameModuleConfig.shootingGame = new ShootingGameController();

        StageManager.legacyScaling = true;
    };


    constructor() {
        if(TombstoneGameModuleConfig.instance) {
            throw new Error("TombstoneGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}